'use es6';

import { getIsStarterPageTemplate, getIsAdvancedPageTemplateWithAccess } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
export const mapStateToTinyMCEConfig = state => {
  const isStarterPageTemplate = getIsStarterPageTemplate(state);
  const isAdvancedPageTemplateWithAccess = getIsAdvancedPageTemplateWithAccess(state);
  return {
    useEmbed: isAdvancedPageTemplateWithAccess,
    usePersonalization: !isStarterPageTemplate,
    useSourceCode: isAdvancedPageTemplateWithAccess
  };
};